// SPDX-License-Identifier: AGPL-3.0-or-later

import UnicodeEmojis from '@app/features/expressions/utils/UnicodeEmojis';
import type {ReactionEmoji} from '@app/features/messaging/utils/ReactionUtils';

const HEART_SHORT_NAMES_WITHOUT_HEART = new Set(['cupid']);

export function unicodeHeartShortNameMatches(name: string): boolean {
	const normalized = name.toLowerCase();
	return normalized.includes('heart') || HEART_SHORT_NAMES_WITHOUT_HEART.has(normalized);
}

export function isUnicodeHeartReaction(emoji: ReactionEmoji): boolean {
	if (emoji.id != null) return false;
	const surrogate = UnicodeEmojis.normalizeEmojiNameToSurrogate(emoji.name);
	const shortName = UnicodeEmojis.getSurrogateName(surrogate) ?? emoji.name;
	return unicodeHeartShortNameMatches(shortName);
}
